module.exports = __webpack_public_path__ + "static/media/krushna_bankar.6963bf2d.png";